import * as React from "react";
import { IRadioOption, RadioList } from "../../Common/radio-list";
import { StateSelectList } from "../../Common/SelectLists";

export const searchIsNotEmpty = (params: LocationSearchParams) => {
  return (
    params.CitySearchTerm !== "" ||
    params.NameSearchTerm !== "" ||
    params.StateSearchTerm !== ""
  );
};

// the search form for searching for locations.
export const LocationSearchForm: React.FunctionComponent<{
  params: LocationSearchParams;
  onSearchChange: (params: LocationSearchParams) => void;
}> = (props: {
  params: LocationSearchParams;
  onSearchChange: (params: LocationSearchParams) => void;
}) => {
  const [params, setParams] = React.useState<LocationSearchParams>(
    props.params
  );

  const handleIntChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = parseInt(e.target.value, 10);

    const newParams = {
      ...params,
      [e.target.name]: value,
    };

    setParams(newParams);
  };
  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value;

    const newParams = {
      ...params,
      [e.target.name]: value,
    };

    setParams(newParams);
  };

  const handleSubmit = (e: React.MouseEvent<HTMLElement>) => {
    props.onSearchChange(params);

    e.preventDefault();
    return false;
  };

  const isDisabled = !searchIsNotEmpty(params);
  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code && e.code.endsWith("Enter")) {
      e.preventDefault();

      if (searchIsNotEmpty(params)) {
        props.onSearchChange(params);
      }

      return false;
    }
    return true;
  };
  const key = Math.floor(Math.random() * 10000);

  const locationTypes: Array<IRadioOption> = [
    {
      key: "rdoHospitalType_" + key,
      value: 0,
      name: "Hospitals",
      isChecked: params.FacilityType === 0,
    },
    {
      key: "rdoHospitalType_" + (key + 1),
      value: 1,
      name: "Nursing Homes",
      isChecked: params.FacilityType === 1,
    },
  ];
  const groupName = "FacilityType";

  return (
    <div className="location-search">
      <h1>Search for a Hospital:</h1>

      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="NameSearchTerm">Facility Name OR Keyword:</label>
            <input
              name="NameSearchTerm"
              id="NameSearchTerm"
              onKeyDown={handleEnter}
              onChange={handleChange}
              className="form-control"
              value={params.NameSearchTerm}
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="CitySearchTerm">City:</label>
            <input
              name="CitySearchTerm"
              id="CitySearchTerm"
              onKeyDown={handleEnter}
              onChange={handleChange}
              className="form-control"
              value={params.CitySearchTerm}
            />
          </div>
        </div>
        <div className="col-sm-6">
          <div className="form-group">
            <label htmlFor="StateSearchTerm">State / Province</label>
            <StateSelectList
              name="StateSearchTerm"
              onChange={handleChange}
              value={params.StateSearchTerm}
            />
          </div>
        </div>
      </div>

      <div className="form-group">
        <fieldset className="radioButtons">
          <legend>Select Facility Type:</legend>

          <RadioList
            handleChange={handleIntChange}
            radioOptions={locationTypes}
            name={groupName}
          />
        </fieldset>
      </div>

      <div className="button-row">
        <button
          type="button"
          className="hgs-button"
          disabled={isDisabled}
          onClick={handleSubmit}
          title="Enter as much info as you have to search for a facility"
        >
          Search Hospitals
        </button>
      </div>

      <p>
        * Please Note: Hospitalgiftshop.com delivers flowers to all hospitals
        listed. Not all hospitals are directly affiliated with
        hospitalgiftshop.com.
      </p>
    </div>
  );
};
